
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
    import 'video.js/dist/video-js.css'
    import videojs, { VideoJsPlayerOptions, VideoJsPlayer } from 'video.js'
    import {ShopGoodsImgListDto} from "@/api/shoppingMall";
    import { checkIsEmpty, asyncDownloadUrl } from '@/utils/util'
    import { ACCESS_KEY_ID, ACCESS_KEY_SECRET } from '@/api'
    import { getSyDictDataInfo } from '@/api/commonConfig'
    import { ImagePreview } from 'vant';
    @Component
    export default class GoodsSwipe extends Vue {
        @Prop({ default: () => { return [] } }) imageList!: ShopGoodsImgListDto[] // 商品图册列表
        @Prop({ default: '' }) videoUrl!: string // 视频文件路径
        @Prop({ default: '' }) poster?: string // 视频封面图
        @Prop({ default: false }) autoplay?: boolean // 是否自动播放
        current = 0
        isPlaying = false
        myPlayer!: VideoJsPlayer // 视频播放器实例
        myPlayerOptions: VideoJsPlayerOptions = {
            bigPlayButton: true, // 是否显示播放按钮（这个播放按钮默认会再左上方，需用CSS设置居中）
            // textTrackDisplay: true,
            // posterImage: true,
            // errorDisplay: true,
            preload: "none",
            autoplay: false,
            controls: true,
            loop: false
        }
        videoMainImage = ''
        imageLength = 0
        checkIsEmpty = checkIsEmpty

        videoServer = '' // 视屏播放地址

        created(){
          this.dictList()
        }

        /**
         * 获取选项数据【字典接口】
         * @param name 查询参数
         * @param list 获取视屏播放地址
         */
        dictList () {
          let param = {
            dictTypeId: 'videoByApp'
          }
          getSyDictDataInfo(param).then(res => {
            this.videoServer = res.data[0].dataName
            if (!checkIsEmpty(this.videoUrl)) {
              this.$nextTick(() => {
                this.initVideo()
              })
            }
          })
        }



        @Watch('imageList', { deep: true,immediate:true })
        changImageList (val: ShopGoodsImgListDto[]) {
            if ( val && val.length > 0 ) {
                val.forEach((item: any, index: number) => {
                    if (Number(item.serialNumber) === 1) {
                        this.videoMainImage = this.$downloadUrl(this.poster || item.imageUrl)
                    }
                    this.getImgBase(item.imageUrl, index)
                })
                this.imageLength = checkIsEmpty(this.videoUrl) ? val.length : val.length + 1
                if (!checkIsEmpty(this.videoUrl)) {
                    this.$nextTick(() => {
                        this.initVideo()
                    })
                }
            }
        }

        async getImgBase (url: string, index: number) {
            // let imgElement: any = document.getElementById(this.data.goodsId)
            let urlBase = await asyncDownloadUrl(url)
            if (!urlBase) {
                urlBase = this.$downloadUrl(url)
            }
            // console.log(index, '==imgElement------', urlBase.slice(0, 80))
            this.$set(this.imageList[index], 'urlBase', urlBase)
        }
        /**
         * @description 图片预览功能
         * @param imageUrl
         */
        imgClick(index:number) {
          let previewArr = []
          this.imageList.map(item => {
            previewArr.push(this.$downloadUrl(item.imageUrl))
          })
          ImagePreview({images:previewArr,startPosition:index})
        }

        initVideo () {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const that = this
            if(!that.videoServer) return false
            this.myPlayer = videojs('example_video_1', { ...this.myPlayerOptions, autoplay: this.autoplay }, function onPlayerReady() {
                // videojs.log('播放器已经准备好了!');
                if (that.autoplay) {
                    this.play()
                }

                // 使用事件监听
                // this.on('ended', function () {
                //     videojs.log('播放结束了!');
                // });

                this.on('play', function () {
                    that.isPlaying = true
                })
            })
        }

        onChange(index) {
            this.current = index;
            if (index === 0) {
                this.isPlaying && (this.myPlayer as any).play()
            } else {
                (this.myPlayer as any).pause()
            }
        }

        // 获取视频播放文件
        getVideoFile (data: string | any): string {
            if (!data) return ''
            return `${this.videoServer }?filePath=${data}&access_key_id=${ACCESS_KEY_ID}&access_key_secret=${ACCESS_KEY_SECRET}`
        }

        beforeDestroy() {
            if (this.myPlayer) {
                this.myPlayer.dispose()
            }
        }
    }
